import { Component, OnInit, inject } from '@angular/core';
import { IStationDeparture } from './departure-monitor.service';
import { IonRouterOutlet, ModalController, IonicModule } from '@ionic/angular';
import { StationsPage } from './stations/stations.page';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-departure-monitor',
    templateUrl: './departure-monitor.page.html',
    styleUrls: ['./departure-monitor.page.scss'],
    imports: [IonicModule, DatePipe, TranslatePipe]
})
export class DepartureMonitorPage implements OnInit {
  private modalController = inject(ModalController);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private routerOutlet = inject(IonRouterOutlet);

  public departures: IStationDeparture[];
  public stationName: string;
  private nameSubscription: Subscription;

  constructor() {
    this.route.data.subscribe((departures: { departures: IStationDeparture[] }) => {
      this.departures = departures.departures;
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const stationId = params.get('stationId');
      if (stationId) {
        if (!this.stationName) {
          this.nameSubscription = this.route.queryParamMap.subscribe(paramMap => {
            this.stationName = paramMap.get('name');
          });
        }
      } else {
        this.openStationSelection();
      }
    });
  }

  ionViewWillLeave() {
    this.nameSubscription.unsubscribe();
  }

  openStationSelection(): void {
    this.modalController
      .create({
        component: StationsPage,
        componentProps: {
          isModal: true
        },
        canDismiss: true,
        presentingElement: this.routerOutlet.nativeEl
      })
      .then((modal: HTMLIonModalElement) => {
        modal.onDidDismiss().then(selectedStation => {
          if (selectedStation.data !== undefined) {
            this.router.navigate(['../', selectedStation.data.id], {
              relativeTo: this.route,
              replaceUrl: true,
              queryParams: { name: selectedStation.data.name }
            });
          }
        });
        modal.present();
      });
  }

}
